// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.type-header .title span {
  font-weight: 800;
  /* vertical-align: middle; */
  padding: 0 5px;
}
.type-header .title app-img {
  display: inline-block;
  vertical-align: middle;
}

.prop-box {
  --background: #f5f5f5;
  border: 1px solid #dfdfdf;
}
.prop-box .price {
  margin: 0 5px;
  font-style: italic;
}

.prop-box.ion-color-success {
  border-color: var(--ion-color-success);
}

.prop-box1 {
  width: 100%;
  margin: 0px;
  position: relative;
}
.prop-box1 .price {
  font-weight: bold;
}
.prop-box1 .img {
  width: 100%;
  border-bottom: 1px solid #dcdcdc;
  text-align: center;
}
.prop-box1 .img .checked-box {
  text-align: start;
  position: absolute;
  z-index: 50;
  color: #fff;
  top: 0;
  font-size: 17px;
  padding: 1px 1px 0 1px;
  width: 22px;
  background: #8BC34A;
  border-bottom-left-radius: 13px;
}

.prop-box.focus {
  opacity: 0.5;
  transition: opacity 0.5s ease-in-out;
}

.prop-box.focus-out {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.title1 {
  font-size: 14px;
  background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/pages/item-deal-props/components/item-deal-props-type/item-deal-props-type.component.scss"],"names":[],"mappings":"AAKI;EACE,gBAAA;EACA,4BAAA;EACA,cAAA;AAJN;AAOI;EACE,qBAAA;EACA,sBAAA;AALN;;AAUA;EAEE,qBAAA;EACA,yBAAA;AARF;AAUE;EAEE,aAAA;EACA,kBAAA;AATJ;;AAaA;EAEE,sCAAA;AAXF;;AAcA;EACE,WAAA;EAEA,WAAA;EACA,kBAAA;AAZF;AAgBE;EACE,iBAAA;AAdJ;AAiBE;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;AAfJ;AA+BI;EAWE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;AAvCN;;AAmDA;EACE,YAAA;EAKA,oCAAA;AAhDF;;AAkDA;EACE,UAAA;EAKA,oCAAA;AA/CF;;AAgEA;EACE,eAAA;EACA,gBAAA;AA7DF","sourcesContent":[".type-header {\n  //margin: 5px 10px;\n\n  .title {\n\n    span {\n      font-weight: 800;\n      /* vertical-align: middle; */\n      padding: 0 5px;\n    }\n\n    app-img {\n      display: inline-block;\n      vertical-align: middle;\n    }\n  }\n}\n\n.prop-box {\n\n  --background: #f5f5f5;\n  border: 1px solid #dfdfdf;\n\n  .price\n  {\n    margin: 0 5px;\n    font-style: italic;\n  }\n}\n\n.prop-box.ion-color-success {\n  //color: #529546;\n  border-color: var(--ion-color-success);\n}\n\n.prop-box1 {\n  width: 100%;\n  //border: 1px solid rgba(0, 0, 0, 0.1);\n  margin: 0px;\n  position: relative;\n\n  //border-radius: 15px;\n\n  .price {\n    font-weight: bold;\n  }\n\n  .img {\n    width: 100%;\n    border-bottom: 1px solid #dcdcdc;\n    text-align: center;\n\n    img {\n      //border-top-right-radius: 15px;\n      //border-top-left-radius: 15px;\n    }\n\n    ::ng-deep {\n      .background {\n        //height: 60px;\n        //border-top-right-radius: 15px;\n        //border-top-left-radius: 15px;\n      }\n    }\n\n\n    .checked-box {\n      //text-align: center;\n      //position: absolute;\n      //z-index: 50;\n      //color: #fff;\n      //top: 0;\n      //font-size: 60px;\n      //width: 100%;\n      //background: #ffffff75;\n      //height: 60px;\n\n      text-align: start;\n      position: absolute;\n      z-index: 50;\n      color: #fff;\n      top: 0;\n      font-size: 17px;\n      padding: 1px 1px 0 1px;\n      width: 22px;\n      background: #8BC34A;\n      border-bottom-left-radius: 13px;\n\n      //div{\n      //  margin-top: -12px;\n      //  text-shadow: 1px 1px 3px #656565;\n      //}\n\n\n    }\n  }\n}\n\n.prop-box.focus {\n  opacity: 0.5;\n  -webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 0.5s ease-in-out;\n  -ms-transition: opacity 0.5s ease-in-out;\n  -o-transition: opacity 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n}\n.prop-box.focus-out{\n  opacity: 1;\n  -webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 0.5s ease-in-out;\n  -ms-transition: opacity 0.5s ease-in-out;\n  -o-transition: opacity 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.prop-box.active {\n  //border: 1px solid #8BC34A;\n  //\n  //.img {\n  //  border-color: #8BC34A;\n  //}\n  //background: inherit;\n}\n\n.prop-box:active {\n  //opacity: 0.8;\n  //border:1px solid #0ec254;\n}\n\n.title1 {\n  font-size: 14px;\n  background: #fff;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
